










import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    components: {
        BaseButton,
    },
})
export default class UpgradeModalPlan extends Vue {
    @Prop({ type: String }) name!: string
    @Prop({ type: String }) price!: string

    get displayDesktop() {
        return this.breakpoints.lg || this.breakpoints.xl
    }
}
